import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from './redux/rootReducer';

const middlewares = [thunk];

if (process.env.NODE_ENV === `development`) {
  middlewares.push(logger);
}

export default function configureStore(preloadedState) {
  return createStore(rootReducer, preloadedState, applyMiddleware(...middlewares));
}
